<div class="p-7 max-w-[90vw]">
  <!-- Header -->
  <div class="flex items-center justify-between mb-6">
    <p class="text-[16px] font-bold text-[var(--base-text-alt-dark)] m-0">Add Samples</p>
    <span class="material-icons cursor-pointer text-[var(--tertiary-text)] text-[20px] rounded-full w-7 h-7 flex items-center justify-center hover:bg-[var(--app-base)]"
          (click)="closeDialog()">close</span>
  </div>

  <!-- Toolbar -->
  <div class="flex items-center gap-2.5 mb-5 flex-wrap">
    <!-- Search -->
    <div class="relative">
      <span class="material-icons absolute left-2.5 top-1/2 -translate-y-1/2 text-[18px] text-[var(--tertiary-text)]">search</span>
      <input type="text" placeholder="Search samples..." [(ngModel)]="searchText" (ngModelChange)="searchLabSamples()"
        class="py-2 pl-9 pr-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] w-[200px] outline-none transition-colors bg-[var(--app-base)] focus:border-[var(--primary-dark)] text-[var(--base-text-alt-dark)]">
    </div>

    <!-- Sample Group -->
    <mat-form-field class="w-[250px]" appearance="outline">
      <mat-label>Sample Group</mat-label>
      <mat-select multiple [(ngModel)]="selectedSampleGroups" (ngModelChange)="getLabSampleList();isFilterBtnVisible = true">
        <mat-option *ngFor="let sampleGroup of sampleGroups" [value]="sampleGroup.id">
          {{sampleGroup.name}} <span *ngIf="sampleGroup.isGrid" class="text-[10px] text-[#2563eb] font-semibold">- Grid</span>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Clear Filters -->
    <button *ngIf="isFilterBtnVisible" (click)="resetFilter()"
      class="py-2 px-3.5 border-[1.5px] border-[var(--app-border)] rounded-lg text-xs font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
      <span class="material-icons text-[16px]">filter_alt_off</span> Clear Filters
    </button>

    <div class="flex-1"></div>

    <!-- Date Range -->
    <div class="flex gap-2.5">
      <ui-datepicker label="START DATE" [value]="filterStartDate" (valueChange)="filterStartDate=$event; filterDateRange()"></ui-datepicker>
      <ui-datepicker label="END DATE" [value]="filterEndDate" (valueChange)="filterEndDate=$event; filterDateRange()"></ui-datepicker>
    </div>
  </div>

  <!-- Table -->
  <app-samples-table [callResponse]="dataSource" [isDialog]="true" [pinTypeId]="pinTypeId" (emitSelectedSamples)="closeDialog($event)" (paginateChange)="currentPage=$event.currentPage;pageSize=$event.pageSize;getLabSampleList()"></app-samples-table>
</div>
